import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { getOperatorCatalog } from "./filterBuilderConstants";

const FilterConditionInput = ({ condition, fieldMeta, updateConditionValue, updateConditionOperator }) => {
  const { t } = useTranslation();
  const operatorCatalog = getOperatorCatalog(t);
  const operators = operatorCatalog[fieldMeta.type] || operatorCatalog.string;

  if (!condition.operator) {
    return (
      <Select value={condition.operator} onValueChange={(val) => updateConditionOperator(condition.id, val)}>
        <SelectTrigger className="w-48">
          <SelectValue placeholder={t("filterComp.operator")} />
        </SelectTrigger>
        <SelectContent>
          {operators.map((op) => (
            <SelectItem key={op.value} value={op.value}>{op.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  if (condition.operator === "isempty" || condition.operator === "isnotempty") {
    return null;
  }

  if (condition.operator === "between") {
    const inputType = fieldMeta.type === "date" || fieldMeta.type === "datetime" ? "date" : "text";
    return (
      <div className="flex items-center space-x-2">
        <Input
          type={inputType}
          value={condition.values?.[0] || ""}
          onChange={(e) => updateConditionValue(condition.id, 0, e.target.value, true)}
          placeholder={t("filterComp.minValue")}
        />
        <span className="text-muted-foreground text-sm">{t("filterComp.and")}</span>
        <Input
          type={inputType}
          value={condition.values?.[1] || ""}
          onChange={(e) => updateConditionValue(condition.id, 1, e.target.value, true)}
          placeholder={t("filterComp.maxValue")}
        />
      </div>
    );
  }

  if (condition.operator === "in" || condition.operator === "notin") {
    return (
      <Input
        placeholder={t("filterComp.commaValues")}
        value={Array.isArray(condition.values) ? condition.values.join(",") : ""}
        onChange={(e) =>
          updateConditionValue(
            condition.id,
            0,
            e.target.value.split(",").map((item) => item.trim()).filter(Boolean),
            true
          )
        }
      />
    );
  }

  if (fieldMeta.type === "boolean") {
    return (
      <Select
        value={String(condition.value)}
        onValueChange={(val) => updateConditionValue(condition.id, 0, val === "true", false)}
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder={t("filterComp.choose")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="true">{t("common.yes")}</SelectItem>
          <SelectItem value="false">{t("common.no")}</SelectItem>
        </SelectContent>
      </Select>
    );
  }

  if (fieldMeta.type === "enum") {
    return (
      <Select
        value={condition.value || ""}
        onValueChange={(val) => updateConditionValue(condition.id, 0, val, false)}
      >
        <SelectTrigger className="w-full md:w-48">
          <SelectValue placeholder={t("filterComp.chooseValue")} />
        </SelectTrigger>
        <SelectContent>
          {(fieldMeta.options || []).map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.labelKey ? t(option.labelKey) : option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  const inputType =
    fieldMeta.type === "date" || fieldMeta.type === "datetime"
      ? "date"
      : fieldMeta.type === "numeric"
      ? "number"
      : "text";

  return (
    <Input
      type={inputType}
      value={condition.value || ""}
      onChange={(e) => updateConditionValue(condition.id, 0, e.target.value, false)}
      placeholder={t("filterComp.value")}
    />
  );
};

export default FilterConditionInput;
